export default "__VITE_ASSET__BPz0QnPk__"